import { Component, Output, EventEmitter, Input, ViewChild, QueryList } from '@angular/core';
import { Validators, FormGroupDirective, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DataService } from '../../../service/data.service';
import { ZusammenfassungService } from '../../../service/zusammenfassung.service';
import { AntragWeitereFragenComponent } from '../../antrag/antrag-weitere-fragen/antrag-weitere-fragen.component';
import { KfzAntragComponent } from '../../antrag/kfz-antrag/kfz-antrag.component';
import { DatenBeratungsprotokollComponent } from '../../daten-beratungsprotokoll/daten-beratungsprotokoll.component';
import { DatenschutzPolicyComponent } from '../../datenschutz-policy/datenschutz-policy.component';
import { VereinbarungKommunikationComponent } from '../../vereinbarung-kommunikation/vereinbarung-kommunikation.component';
import { showRegion, showBmStufe } from '../../../../shared/utils';
import {TranslateService} from '@ngx-translate/core';
import {ProduktArt} from '../../../../shared/enum';
import { AppTextareaComponent } from '../../app-textarea/app-textarea.component';
import { KaskoKfzComponent } from '../../calculatekfz/kaskokfz/kaskokfz.component';

@Component({
  selector: 'app-kfz-zusammenfassung',
  templateUrl: './kfz-zusammenfassung.component.html',
  styleUrls: ['./kfz-zusammenfassung.component.scss']
})
export class KfzZusammenfassungComponent {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  antragsart: number;

  @Input()
  kfzAntragComponent: KfzAntragComponent;

  @Input()
  datenBeratungsprotokollComponent: DatenBeratungsprotokollComponent;

  @Input()
  antragWeitereFragenComponent: AntragWeitereFragenComponent;

  @Input()
  expertMode: boolean;

  @Input()
  motorrad: boolean;

  @Input()
  geburtsdatumZweiterZulassungsbesitzer: Date;

  @Input()
  kaskoComponents: QueryList<KaskoKfzComponent>;

  @Output()
  korrekturEvent = new EventEmitter();

  produktArt = ProduktArt;

  @ViewChild('_besondereAnmerkungen') besondereAnmerkungenComponent: AppTextareaComponent;

  preselectedSbVariante = 'genereller Selbstbehalt';

  constructor(public zusammenfassungService: ZusammenfassungService, public dataService: DataService, public translateService: TranslateService) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      besondereAnmerkungen: new UntypedFormControl(''),
      vereinbarungKommunikation: VereinbarungKommunikationComponent.createVereinbarungKommunikation(),
      datenschutzPolicy: DatenschutzPolicyComponent.createDatenschutzPolicy(),
      allgemeineVertragsgrundlagen: new UntypedFormControl('', Validators.requiredTrue),
    });
  }

  get besondereAnmerkungen() { return this.formGroup.get('besondereAnmerkungen'); }
  get vereinbarungKommunikation() { return this.formGroup.get('vereinbarungKommunikation'); }
  get datenschutzPolicy() { return this.formGroup.get('datenschutzPolicy'); }
  get allgemeineVertragsgrundlagen() { return this.formGroup.get('allgemeineVertragsgrundlagen'); }


  showKaskoPreselectValues(idx: number) {
    return this.kaskoComponents.toArray()[idx].showOaemtcInfoForKaskoVariante;
  }

  get showRegion() {
    return showRegion(this.kfzAntragComponent.motorrad, this.kfzAntragComponent.risikoKfzComponents);
  }
  get showBmStufe() {
    return showBmStufe(this.kfzAntragComponent.motorrad, this.kfzAntragComponent.risikoKfzComponents);
  }

  get showOffeneSchaeden(){
    return this.kfzAntragComponent.showOffeneSchaeden;
  }
  get showAnzahlKaskoSchaeden() {
    return this.kfzAntragComponent?.kaskoschaedenAnzahl.value &&
      (this.kfzAntragComponent?.hdiKfzMotorradVersicherung.value === '1' && this.kfzAntragComponent.kaskoVorversicherung.value === '2' ||
      this.kfzAntragComponent?.hdiKfzMotorradVersicherung.value === '2' && this.kfzAntragComponent.kaskoVorversicherung.value === '1' ||
      this.kfzAntragComponent?.hdiKfzMotorradVersicherung.value === '2' && this.kfzAntragComponent.kaskoVorversicherung.value === '2');
  }
}
